/**
 * Section: Lepro Hotspot Banner
 * File: assets/section-lepro-hotspot.js
 *
 * Desktop：hover 触发热点显示商品卡片
 * Mobile：卡片隐藏（由 CSS 控制），热点仅作视觉装饰
 */

(function () {
  'use strict';

  class HotspotBanner {
    constructor(section) {
      this.section = section;
      this.hotspots = Array.from(section.querySelectorAll('.hs-hotspot'));

      // 保存每个热点的原始 direction，供重新初始化时使用
      this._originalDirections = new Map(
        this.hotspots.map((h) => [h, h.dataset.direction])
      );

      this._init();
    }

    _init() {
      this._bindingController = new AbortController();
      const signal = this._bindingController.signal;

      this.hotspots.forEach((hotspot) => {
        hotspot.dataset.direction = this._originalDirections.get(hotspot);
        if (hotspot.dataset.direction === 'auto') {
          this._resolveAutoDirection(hotspot);
        }
        this._bindHover(hotspot, signal);
      });
    }

    /**
     * 根据热点位置智能判断卡片弹出方向
     */
    _resolveAutoDirection(hotspot) {
      const x = parseFloat(hotspot.style.left) || 50;
      const y = parseFloat(hotspot.style.top) || 50;
      let dir;
      if (x > 60 && y > 60)  dir = 'top-left';
      else if (x > 60)        dir = 'bottom-left';
      else if (y > 60)        dir = 'top-right';
      else                    dir = 'bottom-right';
      hotspot.dataset.direction = dir;
    }

    /**
     * Desktop：hover 触发点或卡片时展开，离开后延迟关闭
     */
    _bindHover(hotspot, signal) {
      const trigger = hotspot.querySelector('.hs-hotspot__trigger');
      const card    = hotspot.querySelector('.hs-hotspot__card');
      let timer;

      const open = () => { clearTimeout(timer); this._open(hotspot); };
      const scheduleClose = () => { timer = setTimeout(() => this._close(hotspot), 150); };

      trigger.addEventListener('mouseenter', open, { signal });
      trigger.addEventListener('mouseleave', scheduleClose, { signal });
      card.addEventListener('mouseenter', open, { signal });
      card.addEventListener('mouseleave', scheduleClose, { signal });
    }

    _open(hotspot) {
      this.hotspots.forEach((h) => { if (h !== hotspot) this._close(h); });
      hotspot.classList.add('is-open');
      hotspot.querySelector('.hs-hotspot__trigger').setAttribute('aria-expanded', 'true');
      hotspot.querySelector('.hs-hotspot__card').setAttribute('aria-hidden', 'false');
    }

    _close(hotspot) {
      hotspot.classList.remove('is-open');
      hotspot.querySelector('.hs-hotspot__trigger').setAttribute('aria-expanded', 'false');
      hotspot.querySelector('.hs-hotspot__card').setAttribute('aria-hidden', 'true');
    }

    destroy() {
      if (this._bindingController) this._bindingController.abort();
    }
  }

  /* ----------------------------------------------------------
     初始化 & 生命周期
  ---------------------------------------------------------- */

  function initSection(section) {
    if (section._hotspotBanner) return;
    section._hotspotBanner = new HotspotBanner(section);
  }

  function initAll() {
    document.querySelectorAll('.lepro-hotspot-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ----------------------------------------------------------
     Shopify 主题编辑器支持
  ---------------------------------------------------------- */

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    if (section.classList.contains('lepro-hotspot-section')) {
      if (section._hotspotBanner) section._hotspotBanner.destroy();
      delete section._hotspotBanner;
      initSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const banner = e.target._hotspotBanner;
    if (banner) banner.destroy();
    e.target._hotspotBanner = null;
  });

  document.addEventListener('shopify:block:select', (e) => {
    const hotspot = e.target;
    if (!hotspot.classList.contains('hs-hotspot')) return;
    const banner = hotspot.closest('.lepro-hotspot-section')?._hotspotBanner;
    if (!banner) return;
    banner._open(hotspot);
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const hotspot = e.target;
    if (!hotspot.classList.contains('hs-hotspot')) return;
    hotspot.closest('.lepro-hotspot-section')?._hotspotBanner?._close(hotspot);
  });
})();
